// extracted by mini-css-extract-plugin
export default {"wrapper":"B_-z"};